<template>
  <div id="faq-page">
    <!-- JUMBOTRON -->
    <div class="faq-jumbotron">
      <div class="faq-jumbotron-content lg:p-32 md:p-24 sm:p-16 p-8 rounded-lg mb-base">
        <h1 class="mb-1 text-white">2배 빠른 영어! 말하면서 동시에 쓴다.</h1>
        <p class="text-white">토킹클래스는 매일 1시간씩 공부하는 프로그램으로 30분은 학습자 중심의 세스토플러로 INPUT 자기주도 학습을 하고 30분은 교사와 함께 점검 및 OUTPUT
          교재학습을 통해서 표현중심의 응용학습을 하게 됩니다.
        </p>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-2/5 lg:w-1/5">
        <vx-card>
            <div>
              <student-info/>
            </div>
            <vs-divider></vs-divider>
            <div class="mt-12">
              <banner-info />
            </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-3/5 lg:w-4/5 mt-4 md:mt-0">
        <vx-card title="학습 결과">

          <vs-collapse type="border" accordion>
            <vs-collapse-item :key="index" v-for="(stepList, index) in studyResultList">
              <div slot="header">
                <div class="vx-row flex flex-wrap justify-between">
                  <div class="vx-col flex w-1/2 h-12">
                    <feather-icon icon="MenuIcon" svgClasses="w-5 h-5 stroke-current mr-1"/>
                    <p class="mt-2">{{ displayUnitName(stepList.unit)}}</p>
                  </div>
                  <!-- <div class="vx-col flex w-1/2 justify-end mr-auto">
                    <vs-button type="flat" @click="onStartStudy(stepList.unit)" >학습하기</vs-button>
                  </div> -->
                </div>
              </div>

              <vs-table :data="stepList.schedule" stripe>
                <template slot="thead">
                  <vs-th>순서</vs-th>
                  <vs-th>Step</vs-th>
                  <vs-th style="width: 30%">학습메뉴</vs-th>
                  <vs-th>학습시간</vs-th>
                  <vs-th>힌트사용</vs-th>
                  <vs-th>학습일</vs-th>
                  <vs-th>학습결과</vs-th>
                </template>

                <template slot-scope="{data}">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td>
                        <p class="product-name font-medium truncate">{{ indextr + 1}}</p>
                      </vs-td>

                      <vs-td>
                        <p class="product-name font-medium truncate">{{ tr.stepName }}</p>
                      </vs-td>

                      <vs-td>
                        <p >{{ tr.menuName }}</p>
                      </vs-td>

                      <vs-td>
                        <p class="product-name font-medium truncate">{{ displayTime(tr.studyTime) }}</p>
                      </vs-td>

                      <vs-td>
                        <p class="product-name font-medium truncate">{{ displayHintUseNum(tr.hintUseNum) }}</p>
                      </vs-td>

                      <vs-td>
                        <p class="product-name font-medium truncate">{{ displayStudyDate(tr.studyDate) }}</p>
                      </vs-td>

                      <vs-td>
                        <feather-icon v-if="tr.studyResultData" icon="SearchIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="showResultDetail(tr.studyResultData)"/>
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
            </vs-table>
            </vs-collapse-item>
          </vs-collapse>  
        </vx-card>

        <vs-popup
          title="학습결과"
          :active.sync="showMenuStudyResult">
          <div class="con-exemple-prompt">
            <vs-table :data="menuStudyResult" stripe>
              <template slot="thead">
                <vs-th>문제</vs-th>
                <vs-th>정답</vs-th>
                <vs-th>입력값</vs-th>
                <vs-th>결과</vs-th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                      <p>{{ tr.question }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.answer }}</p>
                    </vs-td>
                    <vs-td>
                      <p>{{ tr.userAnswer }}</p>
                    </vs-td>
                    <vs-td>
                      <p :class="cssMenuStudyResult(tr.result)">{{ dispMenuStudyResult(tr.result) }}</p>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </vs-popup>  

      </div>
    </div>
  </div>
</template>

<script>
import { fetchData } from '@/api/module'
import StudentInfo  from './StudentInfo'
import BannerInfo  from './BannerInfo'

export default {
  components: {
    StudentInfo,
    BannerInfo
  },
  data () {
    return {
      userInfo: null,
      studyResultList: [],
      showMenuStudyResult: false,
      menuStudyResult: []
    }
  },
  props: {
    bookCode: String
  },
  computed: {
  },
  methods: {
    dispMenuStudyResult (result) {
      if (result) {
        return '정답'
      } else {
        return '오답'
      }
    },
    cssMenuStudyResult (result) {
      if (result) {
        return 'text-primary'
      } else {
        return 'text-danger'
      }
    },
    showResultDetail (studyResultData) {
      this.menuStudyResult = JSON.parse(studyResultData)
      this.showMenuStudyResult = true
    },
    displayUnitName (unit) {
      if (unit === null) return
      return unit.replace('U', 'Unit ')
    },
    displayStudyDate (studyDate) {
      if (studyDate === null) return
      return studyDate.substring(0, 16)
    },
    displayHintUseNum (hintUseNum) {
      if (hintUseNum === null) return
      return `${hintUseNum  }회`
    },
    displayTime (studyTime) {
      if (studyTime === null) return

      const min = studyTime / 60
      const second =  studyTime % 60
      return `${this.padLeft(parseInt(min), 2)}:${this.padLeft(parseInt(second), 2)}`
    },
    padLeft (nr, n, str) {
      return Array(n - String(nr).length + 1).join(str || '0') + nr
    },
    arrangeData (scheduleList) {
      
      let unitCode = ''
      let stepList = new Array()
      const unitList = new Array()
      for (let i = 0; i < scheduleList.length; i++) {
        if (unitCode !== scheduleList[i].unitCode) {
          unitCode = scheduleList[i].unitCode
          if (stepList.length > 0) {
            unitList.push({unit: stepList[0].unitCode, schedule: stepList.slice()})
            stepList = new Array()
          }
          stepList.push(scheduleList[i])
        } else {
          stepList.push(scheduleList[i])
        }
      }

      if (stepList.length > 0) {
        unitList.push({unit: stepList[0].unitCode, schedule: stepList.slice()})
      }
      return unitList
    },
    async loadStudyResultList () {
      try { 
        const params = {
          bookCode: this.bookCode,
          userID: this.userInfo.userID
        }
        const { data } = await fetchData('/study-result', params)
        this.studyResultList = this.arrangeData(data.list)
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    this.loadStudyResultList()
  },
  mounted () {
  }
}

</script>

<style lang="scss">
#faq-page {
    .faq-jumbotron-content {
        background-image: url('../assets/images/pages/faq.jpg');
        background-size: cover;
    }

    .faq-bg {
        background-color: #fff;
    }
}
</style>